import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import { ETripTaskType } from 'types/trips';
import { ELocationMode } from 'components/trips/trip-create-task-modal/types';
import { CoordinatesForm } from '../coordinates-form';
import { LocationSwitcher } from '../location-switcher';
import { SharedAddressFields } from '../shared-address-fields';

export const LocationTaskForm = () => {
  const { t } = useTranslation('trip');

  const { coordinates, address, setLocationMode, setCoordinates, setAddress, locationMode, taskType, cargoTrips } =
    useTripTaskStore();

  const showFromCargo =
    cargoTrips.length === 1 &&
    (taskType === ETripTaskType.loading ||
      taskType === ETripTaskType.unloading ||
      taskType === ETripTaskType.return_asset);

  const getCargoAddress = () => {
    if (cargoTrips.length !== 1) return undefined;
    const cargo = cargoTrips[0].cargo;
    if (taskType === ETripTaskType.loading) {
      return cargo.loadingAddress;
    } else if (taskType === ETripTaskType.unloading) {
      return cargo.unloadingAddress;
    } else if (taskType === ETripTaskType.return_asset) {
      return cargo.assetReturnAddress ?? undefined;
    }
    return undefined;
  };

  const renderForm = () => {
    if (locationMode === ELocationMode.fromCargo) {
      const cargoAddress = getCargoAddress();
      if (cargoAddress) {
        return <SharedAddressFields value={cargoAddress} disabled />;
      }
    }
    if (locationMode === ELocationMode.coordinates) {
      return <CoordinatesForm value={coordinates} onChange={setCoordinates} />;
    }
    return <SharedAddressFields value={address} onChange={setAddress} />;
  };

  return (
    <Flex gap='large' vertical>
      <Typography.Text type='secondary'>{t('select_location_mode')}</Typography.Text>
      <LocationSwitcher value={locationMode} showFromCargo={showFromCargo} onChange={setLocationMode} />
      {renderForm()}
    </Flex>
  );
};
